import type {LicenseInfo} from '@github-ui/code-view-sidebar/types'
import {useMemo} from 'react'
import {RepoTitle} from './components/RepoTitle'
import {CodeViewHeaderActions} from './components/RepoHeaderActions'
import {RepoMobileDetails} from './components/RepoMobileDetails'
import type {HeaderResponse} from './types'
import {deriveRepoPaths} from './utils/repo-paths'

/** Data extracted from overviewFiles for the mobile about section. */
export interface OverviewFilesData {
  license?: LicenseInfo
  hasReadme: boolean
  hasCodeOfConduct: boolean
  hasContributing: boolean
  hasSecurityPolicy: boolean
}

export interface CodeViewHeaderProps {
  /** The header payload data from the Rails route query */
  headerData: HeaderResponse
  /** Overview file presence flags used by the mobile about section. */
  overviewFiles?: OverviewFilesData
}

/** Repository overview page header component for the code view. */
export function CodeViewHeader({ownerLogin, repoName, viewer, ...rest}: HeaderResponse) {
  const paths = useMemo(() => deriveRepoPaths(ownerLogin, repoName), [ownerLogin, repoName])

  if (!viewer.isLoggedIn) {
    // The logged-out experience renders the header as part of the Rails app.
    return null
  }

  return (
    <div className="tmp-pt-3 tmp-pb-3 border-bottom color-border-muted">
      <div className="d-none d-md-flex flex-wrap flex-md-nowrap flex-items-center flex-justify-end gap-3">
        <div className={'hide-whenNarrow flex-auto min-width-0 width-fit'}>
          <RepoTitle
            repo={rest.repo}
            ownerLogin={ownerLogin}
            repoName={repoName}
            paths={paths}
            isOrgOwned={rest.pin.isOrgOwned}
          />
        </div>
        <div className="flex-shrink-0">
          <CodeViewHeaderActions {...rest} viewer={viewer} paths={paths} />
        </div>
      </div>
      <div className="show-whenNarrow">
        <RepoMobileDetails ownerLogin={ownerLogin} repoName={repoName} {...rest} viewer={viewer} paths={paths} />
      </div>
    </div>
  )
}
